// import StatsComponent from '../components/NurseAssignments/StatsComponent';
// import NurseAcuityComponent from '../components/NurseAssignments/NurseAcuityComponent';
import Cockpit from "../components/Welcome/ic-cockpit"
import NurseView from "./NurseView"
import KPIDashboard from "./KPIDashboard"
import ScheduleTemplates from "./ScheduleTemplates"
import { usePermissions } from "../hooks/queries/usePermissions"
import { PageLoader } from "../components/Authentication/page-loader"
import { useSelector } from "react-redux"
import DailyCalendar from "./DailyCalendar"
import useFetchSchedules from "../hooks/useFetchSchedules/useFetchSchedules"
import { useEffect } from "react"

function Welcome({ setRenderedHomeComponent, sidebarOpen }) {
	const { data: permissionsPayload } = usePermissions()
	const permissions = permissionsPayload?.permissions ?? null
	useFetchSchedules("Welcome")
	const isLocked = useSelector(state => state.schedule.isLocked)
	// Schedule has finished loading when the server-side document_id has been
	// recorded. Used to defer the home-route decision below — without this
	// gate, `isLocked` flips from its `false` default to its real value once
	// the schedule lands, swapping <DailyCalendar /> for <Cockpit /> mid-render.
	const scheduleLoaded = useSelector(state => state.schedule.documentId !== null)

	const write_schedules = permissions?.includes("write:schedules")
	const read_ic_cockpit = permissions?.includes("read:ic-cockpit")
	const read_schedules = permissions?.includes("read:schedules")
	const read_personal_schedules = permissions?.includes("read:schedule-personal")
	const read_kpi_dashboard = permissions?.includes("read:kpi-dashboard")
	const read_scheduler = permissions?.includes("read:templates")

	// A route based on schedule lock state needs the schedule loaded before we
	// can commit. Users routed elsewhere (KPI Dashboard, Schedule Templates,
	// no-access) don't depend on isLocked and don't need to wait.
	const routeDependsOnSchedule =
		(read_personal_schedules && !write_schedules) || read_schedules
	const ready = permissions !== null && (!routeDependsOnSchedule || scheduleLoaded)

	useEffect(() => {
		if (!ready) return
		if (read_personal_schedules && !write_schedules) {
			setRenderedHomeComponent("Nurse View")
		} else if (read_schedules) {
			setRenderedHomeComponent(
				isLocked && read_ic_cockpit ? "IC Cockpit" : "IC Tracker"
			)
		} else if (read_kpi_dashboard) {
			setRenderedHomeComponent("Operational Reports")
		} else if (read_scheduler) {
			setRenderedHomeComponent("Schedule Templates")
		} else {
			setRenderedHomeComponent("none")
		}
	}, [
		ready,
		isLocked,
		read_personal_schedules,
		write_schedules,
		read_schedules,
		read_ic_cockpit,
		read_kpi_dashboard,
		read_scheduler,
		setRenderedHomeComponent
	])

	if (!ready) {
		return <PageLoader />
	}

	if (read_personal_schedules && !write_schedules) {
		return <NurseView sidebarOpen={sidebarOpen} />
	}
	if (read_schedules) {
		return isLocked && read_ic_cockpit ? (
			<Cockpit sidebarOpen={sidebarOpen} />
		) : (
			<DailyCalendar nurseStaffing={true} sidebarOpen={sidebarOpen} />
		)
	}
	if (read_kpi_dashboard) {
		return <KPIDashboard sidebarOpen={sidebarOpen} />
	}
	if (read_scheduler) {
		return <ScheduleTemplates sidebarOpen={sidebarOpen} />
	}
	return (
		<div className={`${sidebarOpen ? "pl-64" : "pl-8"}`}>
			<p>
				Current user has no access to any of the pages. Please contact the support
				team to assign the correct permissions.
			</p>
		</div>
	)
}

export default Welcome
